export default __webpack_public_path__ + "static/media/toledo_10.5fb23f71.png";